import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/404.svg'


const _hoisted_1 = {
  class: "bg_gray",
  style: {"height":"calc(100vh - 49px)"}
}
const _hoisted_2 = { id: "error_page" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row justify-content-center text-center" }
const _hoisted_5 = { class: "col-xl-7 col-lg-9" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "img-fluid",
    width: "550",
    height: "234"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('error.404')), 1)
          ])
        ])
      ])
    ])
  ]))
}